"use client";

import { useEffect, useState } from "react";

const heights = {
  sm: "640px",
  md: "720px",
  lg: "800px",
  xl: "900px",
};

/**
 * Checks whether a particular height breakpoint applies.
 *
 * @param size The height breakpoint to check.
 *
 * @returns A boolean indicating whether the viewport height meets or exceeds the threshold.
 */
export const useHeightBreakpoint = (size: "sm" | "md" | "lg" | "xl"): boolean => {
  const [matches, setMatches] = useState(
    typeof window !== "undefined" ? window.matchMedia(`(min-height: ${heights[size]})`).matches : true,
  );

  useEffect(() => {
    const breakpoint = window.matchMedia(`(min-height: ${heights[size]})`);

    setMatches(breakpoint.matches);

    const handleChange = (value: MediaQueryListEvent) => setMatches(value.matches);

    breakpoint.addEventListener("change", handleChange);
    return () => breakpoint.removeEventListener("change", handleChange);
  }, [size]);

  return matches;
};
